export default function Mission() {
  return (
    <section className="w-full py-16 md:py-24 lg:py-32 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <p className="text-xs md:text-sm tracking-wider uppercase text-secondary-600 font-medium mb-4 md:mb-6">
          Mission
        </p>
        <div className="relative">
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-light text-primary-700 leading-snug">
            We design and develop
            <br />
            modern digital solutions
            <br />
            <span className="font-medium text-primary-800">that stand the test of time</span>
          </h2>

          <p className="text-sm md:text-base text-foreground-600 mt-6 md:mt-8 max-w-xl leading-relaxed">
            Our mission is to deliver software systems built on clean architecture, thoughtful design,
            and rigorous engineering standards. Every solution we create is crafted with long-term
            maintainability, platform stability, and user experience at its core.
          </p>
        </div>
      </div>
    </section>
  );
}